import {useCallback} from 'react';
import {call, select} from 'redux-saga/effects';

import {useStorePost} from "../store";
import {actionEffects as actions} from "../store/actions";
import {selectPostVoteState} from "../store/selectors";
import {useSagaCallback, useSagaEffect} from '../utils/sagas';
import {changeVote} from "../store/votes";
import {apiGet, apiPost} from './client';

function* loadPost(id, commentSort, loadComments) {
    // Always load a post, even if we already loaded it as part of a listing,
    // because we won't have comments for it.
    let url = `/api/v2/post/post.json?id=${id}`;
    if (commentSort) url = `${url}&commentSort=${commentSort}`;
    if (loadComments) url = `${url}&comments=true`;
    const {posts, comments} = yield call(apiGet, url);
    yield actions.postsLoaded(posts);
    if (comments) {
        yield actions.commentListLoaded(`p:${id}`, comments.filter((c) => c.comment_parent_id === 0).map((c) => c.id), comments);
    }
}

export const usePost = (feedbackCh, id, commentSort, loadComments) => {
    useSagaEffect(feedbackCh, useCallback(function* () {
        yield call(loadPost, id, commentSort, loadComments);
    }, [id, commentSort, loadComments]));
    return useStorePost(id, Boolean(loadComments));
};

export const usePostVote = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (post, dir) {
        const voteState = yield select(selectPostVoteState(post.id));
        yield actions.postVoteChanged(post.id, changeVote(voteState, dir));
        try {
            yield call(apiPost, `/api/v2/action/vote`, {
                id: post.id,
                type: true /* post */,
                direction: dir,
            });
        } catch (ex) {
            yield actions.postVoteChanged(post.id, voteState);
            throw ex;
        }
    }, []));
};

export const useHidePost = (feedbackCh = null) => {
    return useSagaCallback(feedbackCh, useCallback(function* (post) {
        yield actions.postHiddenChanged(post.id, true);
        try {
            yield call(apiPost, `/api/v2/action/hide`, {
                id: post.id,
            });
        } catch (ex) {
            yield actions.postHiddenChanged(post.id, false);
            throw ex;
        }
    }, []));
};
